export const API_URL =
  "https://cors-anywhere.herokuapp.com/http://api.openweathermap.org/data/2.5";
